import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  InitiatedUserAs: '',
  PermitType: '',
  PermitDurationEn: '',
  PermitDurationAr: '',
  buyers: [],
  broker: {},
  brokerDetails: {},
  property: {},
  breakdown: {},
  companiesResponse: {},
  usersResponse: {},
  propertyDetails: null,
  permitExclusivity: '',
  savedUnits: [],
  selectedProject: '',
  isDeveloperAndFullProject: false,
};

// eslint-disable-next-line consistent-return
export default function requestPermitReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.REQUEST_PERMIT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.REQUEST_PERMIT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.REQUEST_PERMIT_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action, 'payload', null),
      };
    case types.REQUEST_PERMIT_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.REQUEST_PERMIT_CLEAR_APPLICATION:
      return {
        ...defaultState,
      };
    case types.REQUEST_PERMIT_CHANGE_WORKFLOW_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };
    case types.REQUEST_PERMIT_FETCH_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        propertyDetails: action.payload,
      };

    case types.REQUEST_PERMIT_FETCH_APPLICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        broker: get(action.payload, 'broker', {}),
        InitiatedUserAs: get(action.payload, 'InitiatedUserAs', null),
        PermitDurationEn: get(action.payload, 'PermitDurationEn', null),
        PermitDurationAr: get(action.payload, 'PermitDurationAr', null),
        PermitType: get(action.payload, 'PermitType', null),
        permitExclusivity: get(action.payload, 'permitExclusivity', null),
        projectDetails: get(action.payload, 'projectDetails', null),
        isDeveloperAndFullProject: get(action.payload, 'isDeveloperAndFullProject', null),
      };

    case types.REQUEST_PERMIT_DELETE_BROKER_SUCCESS: {
      return {
        ...state,
        loading: false,
        broker: {},
      };
    }
    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // adding the new action for onchange initiator
    case types.PERMIT_INITIATEOR:
      return {
        ...state,
        InitiatedUserAs: action.payload.value,
      };
    // adding the new action for permit type
    case types.PERMIT_PERMIT_TYPE:
      return {
        ...state,
        PermitType: action.payload.value,
      };
    // adding the new action for permit duration
    case types.PERMIT_PERMIT_DURATION:
      return {
        ...state,
        PermitDurationEn: action.payload.PermitDurationEn,
        PermitDurationAr: action.payload.PermitDurationAr,
      };

    case types.REQUEST_PERMIT_SET_BROKER_DETAILS:
      return { ...state, broker: action.payload };

    case types.SET_PERMIT_EXCLUSIVITY:
      return {
        ...state,
        permitExclusivity: action.payload,
      };

    // Property Management
    case types.ADD_REQUEST_PERMIT_PROPERTIES:
      return {
        ...state,
        loading: true,
      };
    case types.ADD_REQUEST_PERMIT_VALIDATION_ERROR:
      return {
        ...state,
        loading: false,
        validation: action.payload,
      };
    case types.ADD_REQUEST_PERMIT_UNIT_VALIDATION_ERROR:
      return {
        ...state,
        loading: false,
        unitValidation: [...state.unitValidation, action.payload],
      };
    case types.ADD_REQUEST_PERMIT_PROPERTIES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.ADD_REQUEST_PERMIT_PROPERTIES_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.GET_REQUEST_PERMIT_BUILDINGS:
      return {
        ...state,
        loading: true,
      };
    case types.GET_REQUEST_PERMIT_BUILDINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        properties: action.payload,
      };
    case types.GET_REQUEST_PERMIT_BUILDINGS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.GET_REQUEST_PERMIT_UNITS:
      return {
        ...state,
        unitsLoading: true,
      };
    case types.GET_REQUEST_PERMIT_UNITS_SUCCESS:
      return {
        ...state,
        unitsLoading: false,
        savedUnits: action.payload,
        loading: false,
      };
    case types.SET_SELECTED_PROJECT:
      return {
        ...state,
        selectedProject: action.payload,
      };
    case types.GET_REQUEST_PERMIT_UNITS_ERROR:
      return {
        ...state,
        unitsLoading: false,
      };

    default:
      return state;
  }
}
